import type { Board } from "../../board";
import { PRIORITY_LAST, type ProcessableThing } from "../../interfaces";
import { PhysicalThing } from "../../physicalThing";
import { deserializeXY } from "../../serialization";
import { Robot } from "../../mobs/robot";
import { RobotActorState } from "../../interfaces";
import type { XY } from "../../xy";
import { ZOrder } from "../../zOrder";

export class RobotActivationTrap extends PhysicalThing implements ProcessableThing {
	static key = "RobotActivationTrap";
	constructor(xy: XY) {
		super(xy, false);
	}

	getZOrder(): number {
		return ZOrder.ITEM_ON_FLOOR;
	}

	isVisible(): boolean {
		return false;
	}

	processTurn(board: Board): void {
		if (!board.player || !board.player.xy.equals(this.xy)) return;

		for (const thing of board.getPhysicalThings()) {
			if (thing instanceof Robot) {
				thing.setState(RobotActorState.ENGAGING);
			}
		}
		board.removeAtEndOfTurn(this);
	}

	getProcessPriority(): number {
		return PRIORITY_LAST;
	}

	static deserialize(data: any): RobotActivationTrap {
		const t = new RobotActivationTrap(deserializeXY(data.xy));
		t.visualId = data.visualId;
		return t;
	}
}
